/** @jsxImportSource @emotion/react */

import { Redo2 as Redo2Icon } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import history from 'modules/overlay-canvas/addons/history';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal } from 'modules/template-editor/store/editor/selectors';
import { useEditorManager } from 'modules/template-editor/ui/context';

export function Redo() {
  const { t } = useLingui();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useEditorManager();
  const [isActive, setIsActive] = React.useState(history.isInit() ?? history.redoIsActive());

  const onClickRedo = () => {
    if (!fabricManager) return;
    history.redo();
  };

  useEffect(() => {
    history.history.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
    history.index.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
  }, []);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={t({ message: 'Вперед', context: 'redo' })} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton
          variant="ghost"
          icon={<Redo2Icon size={20} strokeWidth={1.5} />}
          onClick={onClickRedo}
          disabled={!isActive}
          tabIndex={0}
        />
      </span>
    </UDTippy>
  );
}
